import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';
import { VehicleValuation } from './vehicle-valuation.model';

export class PublicBundle extends BitfStrapiModel {
  label: string;
  whyToBuy: string;
  isHighlighted: boolean;

  // Relations
  vehiclesValuations: VehicleValuation[];

  get buyPrice() {
    return this.vehiclesValuations.reduce((acc, curr) => acc + curr.buyPrice, 0);
  }
  get sellPrice() {
    return this.vehiclesValuations.reduce((acc, curr) => acc + curr.sellPrice, 0);
  }
  get gainInCash() {
    return this.sellPrice - this.buyPrice;
  }
  get gainInPercentage() {
    return ((this.gainInCash / this.buyPrice) * 100).toFixed(1);
  }
  get netGainInCash() {
    return this.vehiclesValuations.reduce((acc, curr) => acc + curr.netGainInCash, 0);
  }
  get netGainInPercentage() {
    return Number(((this.netGainInCash / this.buyPrice) * 100).toFixed(1));
  }

  get numberOfVehicles() {
    return this.vehiclesValuations?.length;
  }

  get slug(): string {
    return this.vehiclesValuations.map(vehicleValuation => vehicleValuation.garage.slug).join('-');
  }

  get allVehicleFullTitles() {
    return this.vehiclesValuations.map(vehicleValuation => vehicleValuation.garage.fullTitle).join(', ');
  }

  constructor(data?: any) {
    super({
      data,
      hydrateProperties: {
        vehiclesValuations: { model: VehicleValuation },
      },
      serializeProperties: [],
    });
  }
}
